// @ts-ignore
export const AngularApp = window.angular.element(document.querySelector('#zApp'));

export const ROOT_ANGULAR_MODULE_NAME = 'z.react-modules';

export function angularService(serviceName: string): any {
    return AngularApp.injector().get(serviceName);
}

export function angularBroadcast(eventName: string, data: any = {}) {
    return AngularApp.scope().$broadcast(eventName, data);
}

export function angularEmit(eventName: string, data: any = {}) {
    return AngularApp.scope().$emit(eventName, data);
}

export function getCompiledDirective(directiveString: string) {
    const injector = AngularApp.injector();
    let scope;

    const element = injector.invoke([
        '$rootScope',
        '$compile',
        ($rootScope: any, $compile: any) => {
            scope = $rootScope.$new();
            return $compile(directiveString)(scope);
        },
    ]);

    return { element, scope };
}

export function getAngularRootModule() {
    try {
        return window.angular.module(ROOT_ANGULAR_MODULE_NAME);
    } catch {
        return window.angular.module(ROOT_ANGULAR_MODULE_NAME, []);
    }
}

export function addToRootAngularModule(moduleName: string) {
    getAngularRootModule().requires.push(moduleName);
}

export function retryWithDelay(fn, delay = 500) {
    const timeoutId = setTimeout(async () => {
        for (let i = 0; i < 3; i++) {
            try {
                fn();
                await sleep(delay);
                return;
            } catch (error) {
                const e = error;
            }
        }
    }, delay);

    return () => {
        clearTimeout(timeoutId);
    };

    function sleep(delay) {
        return new Promise((resolve) => {
            setTimeout(resolve, delay);
        });
    }
}
